import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bold-button",
  "use": "bold-button-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"bold-button\"><path d=\"M366.885 213.55c23.174-22.623 37.588-54.183 37.588-89.05 0-68.649-55.851-124.5-124.5-124.5H30.5v40h59.973v432H30.5v40H330c83.537 0 151.5-67.963 151.5-151.5 0-70.818-48.846-130.436-114.615-146.95zM130.473 40h149.5c46.593 0 84.5 37.907 84.5 84.5s-37.907 84.5-84.5 84.5h-149.5V40zM330 472H130.473V249H330c61.481 0 111.5 50.019 111.5 111.5S391.481 472 330 472z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol